<template>
  <el-dialog :title="$t('addHousekeepingType.add')" :visible.sync="dialogVisible" width="70%" @close="closeDialog">
    <el-form :model="addHousekeepingTypeInfo" label-width="120px">
      <el-form-item :label="$t('addHousekeepingType.menuName')" required>
        <el-input v-model="addHousekeepingTypeInfo.hktName"
          :placeholder="$t('addHousekeepingType.inputMenuName')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addHousekeepingType.smallIcon')" required>
        <upload-image ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleImageChange"></upload-image>
      </el-form-item>

      <el-form-item :label="$t('addHousekeepingType.menuDesc')">
        <el-input v-model="addHousekeepingTypeInfo.hktDesc"
          :placeholder="$t('addHousekeepingType.inputMenuDesc')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addHousekeepingType.label')">
        <el-input v-model="addHousekeepingTypeInfo.label"
          :placeholder="$t('addHousekeepingType.inputLabel')"></el-input>
      </el-form-item>

      <el-form-item v-if="addHousekeepingTypeInfo.typeCd === '2002'" :label="$t('addHousekeepingType.skipType')"
        required>
        <el-select v-model="addHousekeepingTypeInfo.skipType" style="width:100%"
          :placeholder="$t('addHousekeepingType.selectSkipType')">
          <el-option :label="$t('addHousekeepingType.normalProduct')" value="3"></el-option>
          <el-option :label="$t('addHousekeepingType.internal')" value="1"></el-option>
          <el-option :label="$t('addHousekeepingType.external')" value="2"></el-option>
          <el-option :label="$t('addHousekeepingType.shop')" value="S"></el-option>
          <el-option :label="$t('addHousekeepingType.singleProduct')" value="P"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="addHousekeepingTypeInfo.typeCd === '2002' && ['1', '2'].includes(addHousekeepingTypeInfo.skipType)"
        label="URL">
        <el-input v-model="addHousekeepingTypeInfo.url" :placeholder="$t('addHousekeepingType.inputUrl')"></el-input>
        <div v-if="addHousekeepingTypeInfo.skipType === '1'" class="el-form-item__tip">
          {{ $t('addHousekeepingType.internalUrlTip') }}
        </div>
        <div v-else class="el-form-item__tip">
          {{ $t('addHousekeepingType.externalUrlTip') }}
        </div>
      </el-form-item>

      <el-form-item v-if="['S', 'P'].includes(addHousekeepingTypeInfo.skipType)"
        :label="$t('addHousekeepingType.selectShop')">
        <el-select v-model="addHousekeepingTypeInfo.shopId" style="width:100%"
          :placeholder="$t('addHousekeepingType.selectShop')" @change="selProducts">
          <el-option :label="$t('addHousekeepingType.selectShop')" value=""></el-option>
          <el-option v-for="item in shops" :key="item.shopId" :label="item.shopName" :value="item.shopId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="addHousekeepingTypeInfo.skipType === 'P'" :label="$t('addHousekeepingType.selectProduct')">
        <el-select v-model="addHousekeepingTypeInfo.productId" style="width:100%"
          :placeholder="$t('addHousekeepingType.selectProduct')">
          <el-option :label="$t('addHousekeepingType.selectProduct')" value=""></el-option>
          <el-option v-for="item in products" :key="item.productId" :label="item.prodName"
            :value="item.productId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('common.sort')" required>
        <el-input v-model="addHousekeepingTypeInfo.seq" :placeholder="$t('addHousekeepingType.inputSort')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addHousekeepingType.isShow')" required>
        <el-select v-model="addHousekeepingTypeInfo.isShow" style="width:100%"
          :placeholder="$t('addHousekeepingType.selectShowStatus')">
          <el-option :label="$t('common.yes')" value="Y"></el-option>
          <el-option :label="$t('common.no')" value="N"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveHousekeepingTypeInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveHousekeepingType, queryShopsByAdmin, queryProduct } from '@/api/admin/housekeepingTypeApi'
import UploadImage from '@/components/system/UploadImage'

export default {
  name: 'AddHousekeepingType',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      addHousekeepingTypeInfo: {
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '',
        isShow: '',
        typeCd: '',
        shopId: '',
        storeId: '',
        productId: ''
      },
      shops: [],
      products: []
    }
  },
  methods: {
    open(params) {
      this.resetForm()
      this.addHousekeepingTypeInfo.typeCd = params.typeCd || '1001'
      this.dialogVisible = true
      this.$nextTick(() => {
        this._listShops()
      })
    },
    closeDialog() {
      this.resetForm()
    },
    resetForm() {
      this.addHousekeepingTypeInfo = {
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: '',
        isShow: '',
        typeCd: '',
        shopId: '',
        storeId: '',
        productId: ''
      }
      this.shops = []
      this.products = []
      if (this.$refs.uploadImage) {
        this.$refs.uploadImage.clearImages()
      }
    },
    handleImageChange(images) {
      this.addHousekeepingTypeInfo.hktIcon = images.length > 0 ? images[0] : ''
    },
    async _listShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 100 })
        this.shops = res.data
      } catch (error) {
        console.error('获取店铺列表失败:', error)
      }
    },
    async _listProducts() {
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: this.addHousekeepingTypeInfo.shopId,
          storeId: this.addHousekeepingTypeInfo.storeId
        }
        const res = await queryProduct(params)
        this.products = res.data
      } catch (error) {
        console.error('获取商品列表失败:', error)
      }
    },
    selProducts() {
      if (!this.addHousekeepingTypeInfo.shopId) {
        this.products = []
        return
      }

      if (this.addHousekeepingTypeInfo.skipType === 'P') {
        const shop = this.shops.find(item => item.shopId === this.addHousekeepingTypeInfo.shopId)
        if (shop) {
          this.addHousekeepingTypeInfo.storeId = shop.storeId
          this._listProducts()
        }
      }
    },
    validateForm() {
      if (!this.addHousekeepingTypeInfo.hktName) {
        this.$message.error(this.$t('addHousekeepingType.validate.menuNameRequired'))
        return false
      }
      if (!this.addHousekeepingTypeInfo.hktIcon) {
        this.$message.error(this.$t('addHousekeepingType.validate.iconRequired'))
        return false
      }
      if (!this.addHousekeepingTypeInfo.seq) {
        this.$message.error(this.$t('addHousekeepingType.validate.sortRequired'))
        return false
      }
      if (!this.addHousekeepingTypeInfo.isShow) {
        this.$message.error(this.$t('addHousekeepingType.validate.showStatusRequired'))
        return false
      }
      if (this.addHousekeepingTypeInfo.typeCd === '2002' && !this.addHousekeepingTypeInfo.skipType) {
        this.$message.error(this.$t('addHousekeepingType.validate.skipTypeRequired'))
        return false
      }
      if (this.addHousekeepingTypeInfo.skipType === 'S' && !this.addHousekeepingTypeInfo.shopId) {
        this.$message.error(this.$t('addHousekeepingType.validate.shopRequired'))
        return false
      }
      if (this.addHousekeepingTypeInfo.skipType === 'P') {
        if (!this.addHousekeepingTypeInfo.shopId) {
          this.$message.error(this.$t('addHousekeepingType.validate.shopRequired'))
          return false
        }
        if (!this.addHousekeepingTypeInfo.productId) {
          this.$message.error(this.$t('addHousekeepingType.validate.productRequired'))
          return false
        }
      }
      return true
    },
    async saveHousekeepingTypeInfo() {
      if (!this.validateForm()) return

      try {
        const params = { ...this.addHousekeepingTypeInfo }
        params.shopId = '9999' // 固定值

        if (params.skipType === 'S') {
          if (!params.shopId) {
            this.$message.error(this.$t('addHousekeepingType.validate.shopRequired'))
            return
          }
          params.url = `/pages/cate/cate?shopId=${params.shopId}`
        }

        if (params.skipType === 'P') {
          if (!params.shopId || !params.productId) {
            this.$message.error(this.$t('addHousekeepingType.validate.productRequired'))
            return
          }
          params.url = `/pages/goods/goods?productId=${params.productId}&shopId=${params.shopId}`
        }

        await saveHousekeepingType(params)
        this.$message.success(this.$t('addHousekeepingType.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error('保存家政类型失败:', error)
        this.$message.error(error.message || this.$t('addHousekeepingType.saveFailed'))
      }
    }
  }
}
</script>

<style scoped>
.el-form-item__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}
</style>